import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Shield } from 'lucide-react';
export function Hero() {
  return <section className="pt-32 pb-20 lg:pt-48 lg:pb-32 bg-white" data-id="element-70">
      <div className="max-w-7xl mx-auto px-6" data-id="element-71">
        <div className="max-w-4xl mx-auto text-center" data-id="element-72">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-50 border border-slate-100 mb-8" data-id="element-73">
            <Shield className="w-4 h-4 text-slate-600" data-id="element-74" />
            <span className="text-xs font-semibold uppercase tracking-widest text-slate-600" data-id="element-75">
              Досвід роботи у ЗСУ — 6 років
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-5xl sm:text-6xl lg:text-7xl font-bold tracking-tight text-slate-900 mb-8 leading-[1.1]" data-id="element-76">
            Захист ваших прав <br data-id="element-77" />
            <span className="text-slate-400" data-id="element-78">у військовий час</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-lg lg:text-xl text-slate-500 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-79">
            Професійний юридичний супровід: відстрочка, ВЛК, СЗЧ, виплати та
            звільнення. Ми беремо на себе бюрократію, щоб ви були впевнені у
            своєму майбутньому.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-80">
            <a href="#contact" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-slate-900 hover:bg-slate-800 text-white rounded-full transition-all duration-300 text-sm font-semibold shadow-sm hover:shadow-md" data-id="element-81">
              Безкоштовна консультація
              <ArrowRight className="w-4 h-4" data-id="element-82" />
            </a>
            <a href="#services" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white hover:bg-slate-50 text-slate-900 border border-slate-200 rounded-full transition-all duration-300 text-sm font-semibold" data-id="element-83">
              Всі послуги
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}